import { Box, Button, Card, CardContent, CardHeader, CardMedia, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Link, List, ListItem, ListItemButton, Snackbar, SnackbarContent, Stack } from "@mui/material";
import { useDataContext } from "../contexts/dataContext";
import { useEffect, useState } from "react";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import jwt_decode from "jwt-decode";

export default function Inicio() {
    const { setOpenAvisos, esAsistente } = useDataContext()
    const [open, setOpen] = useState(false)
    const [imagen, setImagen] = useState('')
    const [cambios, setCambios] = useState({})

    const token = sessionStorage.getItem('token')
    const decoded = jwt_decode(token);

    const obtenerReglas = () => {
        let reglas
        const perfilElegido = sessionStorage.getItem('perfilElegido')
        switch (perfilElegido) {
            case 'asistente':
                reglas = decoded.rulesAsistente
                break
            case 'investigador':
                reglas = decoded.rulesJefaturaArea
                break
            case 'coordinacion':
                reglas = decoded.rulesCoordinacion
                break
            case 'jefe':
                reglas = decoded.rulesJefatura
                break
            case 'administracion':
                reglas = decoded.rulesAdministracionProyecto
                break
            default:
                break
        }
        return reglas
    }

    let reglas = decoded.rules

    if (!reglas)
        reglas = obtenerReglas()

    const colocarNombre = (ruta) => {
        const indice = Number(ruta.indexOf("documentosSolicitud")) + 20
        return ruta.slice(indice)

    }

    const handleClose = (id) => {

        switch (id) {
            case 'solicitudesNuevas': setCambios({ ...cambios, 'solicitudesRegistradas': [] })
                break;
            case 'solicitudesActualizadas': setCambios({ ...cambios, 'solicitudesActualizadas': [] })
                break;
            case 'comentarios': setCambios({ ...cambios, 'comentarios': [] })
                break;
            case 'documentosAdjuntados': setCambios({ ...cambios, 'documentosAdjuntados': [] })
                break;
            case 'documentosEliminados': setCambios({ ...cambios, 'documentosEliminados': [] })
                break;
            default: return
        }
    }

    useEffect(() => {
        (async () => {
            await setOpenAvisos(true)
            let url
            for (let j = 0; j < reglas.length; j++) {
                //Coordinadores, jefes de depto, directores, rectoría y secretaría             
                if (reglas[j].action === 'manage' && reglas[j].subject === 'planPresupuestal') {
                    url = `/porPlan/${sessionStorage.getItem('idPlan')}`
                }
                if (reglas[j].action === 'jefatura' && reglas[j].subject === 'area') {
                    url = `/personales/${sessionStorage.getItem('idEntidad')}`
                }
                if (reglas[j].action === 'administracion' && reglas[j].subject === 'proyecto') {
                    url = `/administracion/${sessionStorage.getItem('idEntidad')}`
                }
                if (reglas[j].action === 'asistente' && reglas[j].subject === 'division') {
                    url = `/asistente/${sessionStorage.getItem('idEntidad')}`
                }
            }

            const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/snackbar${url}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil'),
                    "ultimaconexiongestion": sessionStorage.getItem('ultimaConexionGestion')//'2024-12-05 11:24:30.524-06:00'
                }
            })
            console.log(sessionStorage.getItem('ultimaConexionGestion'))
            setCambios(await res.json())

        })();
    }, []);
    return (
        <>
            <Card style={{ marginTop: '100px' }}>
                <CardMedia
                    component="img"
                    image="/images/gestionPresupuestal.jpg"
                    alt="Nadu"
                    style={{ objectFit: 'contain' }}
                />
            </Card>
            <Card style={{ marginTop: '100px' }}>
                <CardContent>
                    <List>
                        <ListItem>
                            <ListItemButton>
                                <Link style={{ cursor: 'pointer' }} href='/images/TransferenciasDestinosMultiples.pdf' target="_blank">Nota informativa (21/enero/2025) Transferencias a múltiples destinos</Link>
                            </ListItemButton>
                        </ListItem>
                        <ListItem>
                            <ListItemButton>
                                <Link style={{ cursor: 'pointer' }} href='/images/Snackbars.pdf' target="_blank">Nota informativa (21/enero/2025) Snackbars indicando los cambios desde la última conexión a AGP</Link>
                            </ListItemButton>
                        </ListItem>
                        <ListItem>
                            <ListItemButton>
                                <Link style={{ cursor: 'pointer' }} href='/images/AvancePresupuestal.pdf' target="_blank">Nota informativa (11/diciembre/2024) Funcionalidad para descargar PDF de avance presupuestal por proyecto y consultar individualmente solicitudes desde el avance presupuestal de una partida</Link>
                            </ListItemButton>
                        </ListItem>
                        <ListItem>
                            <ListItemButton>
                                <Link style={{ cursor: 'pointer' }} href='/images/subirDocumentosGenerales.pdf' target="_blank">Nota informativa (04/diciembre/2024) Funcionalidad para subir documentos en general a las solicitudes</Link>
                            </ListItemButton>
                        </ListItem>
                        <ListItem>
                            <ListItemButton>
                                <Link style={{ cursor: 'pointer' }} href='/images/TimeStamp.pdf' target="_blank">Nota informativa (04/diciembre/2024) TimeStamp en todos los nombres de documentos excepto facturas</Link>
                            </ListItemButton>
                        </ListItem>
                        <ListItem>
                            <ListItemButton>
                                <Link style={{ cursor: 'pointer' }} href='/images/AGPclavesSIIUAM.pdf' target="_blank">Nota informativa (04/diciembre/2024) Claves SIIUAM</Link>
                            </ListItemButton>
                        </ListItem>
                        {esAsistente ?
                            <ListItem>
                                <ListItemButton>
                                    <Link style={{ cursor: 'pointer' }} onClick={() => { setImagen('/images/MejorasNotificacionesPagoContratosAsistente-V2.png'); setOpen(true) }}>Nota informativa (14/noviembre/2024) Pagos por contrato</Link>
                                </ListItemButton>
                            </ListItem>
                            :
                            <ListItem>
                                <ListItemButton>
                                    <Link style={{ cursor: 'pointer' }} onClick={() => { setImagen('/images/MejorasNotificacionesPagoContratosUsuario.png'); setOpen(true) }}>Nota informativa (14/noviembre/2024) Pagos por contrato</Link>
                                </ListItemButton>
                            </ListItem>

                        }
                        <ListItem>
                            <ListItemButton>
                                <Link style={{ cursor: 'pointer' }} onClick={() => { setImagen('/images/MejorasNotificacionesNadu2v2.png'); setOpen(true) }}>Nota informativa (24/octubre/2024) Mejora en las notificaciones</Link>
                            </ListItemButton>
                        </ListItem>

                    </List>
                </CardContent>
            </Card>
            <Dialog open={open} maxWidth='md' fullWidth={true}>
                <DialogContent>
                    <DialogContentText>
                    </DialogContentText>

                    <Box display="flex" justifyContent="center" alignItems="center">
                        <img src={imagen} alt='nota' style={{ maxWidth: "100%" }} />
                    </Box>

                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>Cerrar</Button>
                </DialogActions>
            </Dialog>


            <div>

                <Stack spacing={2} sx={{ maxWidth: 600, position: "absolute", top: 80, right: 10 }}>
                    {cambios.solicitudesRegistradas && cambios.solicitudesRegistradas.length > 0 ?
                        <SnackbarContent key='solicitudesNuevas'
                            message={<><h4 style={{ width: '100%' }}>Solicitudes nuevas desde la última vez que entraste a la aplicación </h4>
                                <ul>
                                    {cambios.solicitudesRegistradas ? cambios.solicitudesRegistradas.map((solicitud) => { return <li key={solicitud.folio}>{solicitud.folio}</li> }) : <></>}
                                </ul>
                            </>}
                            action={
                                <IconButton
                                    size="small"
                                    aria-label="close"
                                    color="inherit"
                                    onClick={() => handleClose('solicitudesActualizadas')}
                                >
                                    <CloseIcon fontSize="small" />
                                </IconButton>
                            }
                        /> : <></>}
                    {cambios.solicitudesActualizadas && cambios.solicitudesActualizadas.length > 0 ?
                        <SnackbarContent key='solicitudesActualizadas'
                            message={<><h4>Solicitudes que cambiaron de estado desde la última vez que entraste a la aplicación </h4>
                                <ul>
                                    {cambios.solicitudesActualizadas ? cambios.solicitudesActualizadas.map((solicitud) => { return <li key={solicitud.folio}>{solicitud.folio} ({solicitud.estado})</li> }) : <></>}
                                </ul>
                            </>}
                            action={
                                <IconButton
                                    size="small"
                                    aria-label="close"
                                    color="inherit"
                                    onClick={() => handleClose('solicitudesActualizadas')}
                                >
                                    <CloseIcon fontSize="small" />
                                </IconButton>
                            }
                        /> : <></>}

                    {cambios.comentarios && cambios.comentarios.length > 0 ?
                        <SnackbarContent key='comentarios'
                            message={<><h4>Se registraron comentarios en las siguientes solicitudes desde la última vez que entraste a la aplicación </h4>
                                <ul>
                                    {cambios.comentarios ? cambios.comentarios.map((comentario) => { return <li key={comentario.solicitud.folio}>{comentario.solicitud.folio}</li> }) : <></>}
                                </ul>
                            </>}
                            action={
                                <IconButton
                                    size="small"
                                    aria-label="close"
                                    color="inherit"
                                    onClick={() => handleClose('comentarios')}
                                >
                                    <CloseIcon fontSize="small" />
                                </IconButton>
                            }
                        /> : <></>}
                    {cambios.documentosAdjuntados && cambios.documentosAdjuntados.length > 0 ?
                        <SnackbarContent key='documentosAdjuntados'
                            message={<><h4>Solicitudes en las que se adjuntaron documentos desde la última vez que entraste </h4>
                                <ul>
                                    {cambios.documentosAdjuntados ? cambios.documentosAdjuntados.map((documento) => { return <li key={documento.folio}>{documento.folio}<br /> (<Link color='primary' size='small' href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/descargarDocumentoSolicitudPDF/${colocarNombre(documento.ruta)}`} download={colocarNombre(documento.ruta)}>{colocarNombre(documento.ruta)}</Link>)</li> }) : <></>}
                                </ul>
                            </>}
                            action={
                                <IconButton
                                    size="small"
                                    aria-label="close"
                                    color="inherit"
                                    onClick={() => handleClose('documentosAdjuntados')}
                                >
                                    <CloseIcon fontSize="small" />
                                </IconButton>
                            }
                        /> : <></>}
                    {cambios.documentosEliminados && cambios.documentosEliminados.length > 0 ?
                        <SnackbarContent key='documentosEliminados'
                            message={<><h4>Solicitudes en las que se eliminaron documentos desde la última vez que entraste </h4>
                                <ul>
                                    {cambios.documentosEliminados ? cambios.documentosEliminados.map((documento) => { return <li key={documento.folio}>{documento.folio} (<span style={{ color: 'red' }}>{colocarNombre(documento.ruta)}</span>)</li> }) : <></>}
                                </ul>
                            </>}
                            action={
                                <IconButton
                                    size="small"
                                    aria-label="close"
                                    color="inherit"
                                    onClick={() => handleClose('documentosEliminados')}
                                >
                                    <CloseIcon fontSize="small" />
                                </IconButton>
                            }
                        /> : <></>}
                </Stack>
            </div>

        </>
    )


}